/*@flow*/
import { useEffect, useState } from 'react';
import { set } from 'ops';
import api from 'lib/api';
import useProjectLayers from 'comps/District/useProjectLayers';
import log from 'lib/log';
import isSmallScreen from 'lib/isSmallScreen';
import getFiltersQuery from 'lib/getFiltersQuery';
import useStoreState from 'lib/useStoreState';
import PATHS from 'const/paths';

export default () => {
  const { filters, projectRefetchHash } = useStoreState({
    filters: getFiltersQuery,
    projectRefetchHash: PATHS.projectRefetchHash,
  });
  const [projects, setProjects] = useState([]);
  useProjectLayers(projects);

  // Fetch projects when filters change
  useEffect(() => {
    if (!filters.has('bbox')) return;

    const fetchProjects = () => {
      // const addFooToFiltersType = v => {
      //   const v2 = I.fromJS(v);
      //   if (!I.List.isList(v2)) return I.List(['foo']);
      //   return v2.includes('foo') ? v2 : v2.push('foo');
      // };
      // const filters2 = filters.update('type', addFooToFiltersType);
      const filters2 = filters;
      const limit = isSmallScreen() ? 50 : 1000;
      const query = { args: { filters: filters2.toJS(), limit } };
      return api.fetchJson('/api/projects', { query });
    };

    // Fetch projects with filter query
    fetchProjects()
      .then((v) => {
        // Set the numProjects
        set('projects.numProjects', v.length);
        setProjects(v);
      })
      .catch(log.error);
  }, [filters && filters.hashCode(), projectRefetchHash]);
};
